import React, { Component } from 'react'
import cx from 'classnames'

import { Flex, Text, Box, Center } from '@chakra-ui/react'
import { FormattedMessage } from 'react-intl'
import SvgIcon from 'src/components/SvgIcon'
import FontAwesomeIconComponent from 'src/components/FontAwesomeIcon/index'
import Button from 'src/components/Button/Button'
import OutsideClickHandler from 'src/components/OutsideClickHandler/index'

import styles from './SpeedDial.module.less'

class SpeedDialComponent extends Component {
  state = {
    isOpen: false,
  }

  componentDidMount() {
    document.addEventListener('keydown', this.onKeyDown, false)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown, false)
  }

  onKeyDown = event => {
    // Hide if ESC is clicked and is currently visible
    if (event.keyCode === 27 && this.state.isOpen === true) {
      this.handleClose()
    }
  }

  handleClose = () => {
    this.setState({
      isOpen: false,
    })
  }

  toggleOpen = () => {
    if (this.state.isOpen) {
      this.setState({
        isOpen: !this.state.isOpen,
      })
    }
  }

  render() {
    const { isOpen } = this.state
    const { actions, highlightedActions, downloadDoc, isAccessibe, isFullWidth } = this.props

    if (
      !((actions && actions.length > 0) || (highlightedActions && highlightedActions.length > 0))
    ) {
      return ''
    }

    const classNamesActions = cx({
      [styles.actions]: true,
      [styles.actionsClosed]: !isOpen,
      [styles.actionsFullWidth]: isFullWidth,
    })

    const classNamesTrigger = cx({
      [styles.trigger]: true,
      [styles.triggerOpened]: isOpen,
    })

    const classNamesBottomNavigation = cx({
      [styles.bottomNavigation]: true,
      [styles.bottomNavigationAlt]: isAccessibe,
    })

    return (
      <OutsideClickHandler onOutsideClick={() => this.toggleOpen()}>
        <Flex align={'center'} className={classNamesBottomNavigation}>
          <Flex flex={1} minW={{ base: 'auto', desktop: 0 }} justify={'start'}></Flex>
          {downloadDoc ? (
            <Button onClick={downloadDoc} size='lg'>
              <FontAwesomeIconComponent icon={['far', 'download']} size='xs' type='white' />
              <Text color='brand.white' ml={'10px'} fontSize={'16px'}>
                <FormattedMessage id='app.global.download' defaultMessage='Download' />
              </Text>
            </Button>
          ) : null}
          <Flex flex={{ base: 1, desktop: 0 }} justify={'end'}>
            <div className={styles.speedDialInner}>
              <div className={classNamesActions}>
                <Button className={styles.smallScreenClose} onClick={this.handleClose}>
                  <SvgIcon type='Plus' className={styles.smallScreenCloseIcon} />
                </Button>
                {actions && actions.length > 0 ? (
                  <div className={styles.actionsList}>
                    {actions.map((action, key) => (
                      <Box
                        borderTop={action.isCenter ? '1px' : ''}
                        borderColor={action.isCenter ? '#E2E8F0' : ''}
                        key={`speed-dial-action-${key}`}
                        p={action.isCenter ? '16px' : { base: '15px', desktop: '24px' }}
                        cursor={'pointer'}
                        onClick={() => action.onClick()}
                      >
                        {action.isCenter ? (
                          <Center>
                            <Flex mr={'10px'}>
                              <FontAwesomeIconComponent
                                icon={action.icon}
                                size='xs'
                                type='wallet-icon'
                              />
                            </Flex>
                            <Text fontSize={'16px'}>{action.name}</Text>
                          </Center>
                        ) : (
                          <Text fontSize={'16px'}>{action.name}</Text>
                        )}
                      </Box>
                    ))}
                  </div>
                ) : (
                  ''
                )}
              </div>
              <Button
                ml={'10px'}
                className={classNamesTrigger}
                onClick={() => this.setState({ isOpen: !this.state.isOpen })}
              >
                <FontAwesomeIconComponent icon={['far', 'gear']} size='xs' type='text' />
              </Button>
            </div>
          </Flex>
        </Flex>
      </OutsideClickHandler>
    )
  }
}

export default SpeedDialComponent
